import { toReadableTimestamp, toReadableTotal } from "../../utils/orderUtils";

export default function RefundInfo({order, handleEditShippingValue}) {
    if (!order) return null;

    return (
        <div className="table-container">
            <table className="table">
                <tbody>
                    <tr>
                        <td style={{ 
                            fontWeight: 'var(--font-weight-semibold)', 
                            color: 'var(--text-primary)',
                            paddingRight: 'var(--spacing-xl)',
                            minWidth: '150px'
                        }}>
                            Refund Amount:
                        </td>
                        <td style={{ 
                            fontWeight: 'var(--font-weight-semibold)', 
                            color: 'var(--error-color)'
                        }}>
                            -${toReadableTotal(order.refund.amount)}
                        </td>
                    </tr>
                    <tr>
                        <td style={{ 
                            fontWeight: 'var(--font-weight-semibold)', 
                            color: 'var(--text-primary)',
                            paddingRight: 'var(--spacing-xl)',
                            minWidth: '150px'
                        }}>
                            Refund Reason:
                        </td>
                        <td 
                            onDoubleClick={() => handleEditShippingValue('refund.reason', order.refund.reason)}
                            style={{ 
                                cursor: 'pointer',
                                color: 'var(--text-secondary)'
                            }}
                        >
                            {order.refund.reason || "No reason provided"}
                        </td>
                    </tr>
                    <tr>
                        <td style={{ 
                            fontWeight: 'var(--font-weight-semibold)', 
                            color: 'var(--text-primary)',
                            paddingRight: 'var(--spacing-xl)',
                            minWidth: '150px'
                        }}>
                            Refund Status:
                        </td>
                        <td style={{ color: 'var(--text-secondary)' }}>
                            {order.refund.status}
                        </td>
                    </tr>
                    <tr>
                        <td style={{ 
                            fontWeight: 'var(--font-weight-semibold)', 
                            color: 'var(--text-primary)',
                            paddingRight: 'var(--spacing-xl)',
                            minWidth: '150px'
                        }}>
                            Refund ID:
                        </td>
                        <td style={{ 
                            fontFamily: 'var(--font-family-mono)', 
                            fontWeight: 'var(--font-weight-medium)',
                            color: 'var(--text-secondary)'
                        }}>
                            {order.refund.id}
                        </td>
                    </tr>
                    <tr>
                        <td style={{ 
                            fontWeight: 'var(--font-weight-semibold)', 
                            color: 'var(--text-primary)',
                            paddingRight: 'var(--spacing-xl)',
                            minWidth: '150px'
                        }}>
                            Refund Timestamp:
                        </td>
                        <td style={{ color: 'var(--text-secondary)' }}>
                            {toReadableTimestamp(order.refund.timestamp)}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    )
}